import React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import axios from "axios";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Typography, Box
} from "@mui/material";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import RecieptVoucherNoHelp from "../../../Helper/RecieptVoucherNoHelp";
import GroupMasterHelp from "../../../Helper/SystemmasterHelp";
import "./MultpleReciept.css";
import { useRecordLocking } from "../../../hooks/useRecordLocking";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import AddButton from "../../../Common/Buttons/AddButton";
import EditButton from "../../../Common/Buttons/EditButton";
import DeleteButton from "../../../Common/Buttons/DeleteButton";
import OpenButton from "../../../Common/Buttons/OpenButton";
import DetailAddButtom from "../../../Common/Buttons/DetailAddButton";
import DetailCloseButton from "../../../Common/Buttons/DetailCloseButton";
import DetailUpdateButton from "../../../Common/Buttons/DetailUpdateButton";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
// import RecieptPaymentReport from "./RecieptPaymentReport";
import Swal from "sweetalert2";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import { PostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck";
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange"
import io from "socket.io-client";
import { fetchAccountBalance } from "../../../Common/GetAccountBalance/GetAccountBalance";
import { Checkbox } from "@mui/material";

const API_URL = process.env.REACT_APP_API;
const socketURL = process.env.REACT_APP_API_URL;

var lblbankname;
var newcashbank;
var newcredit_ac;
var lblacname;
var newUnitCode;
var lblUnitname;
var newAcadjAccode;
var lblAcadjAccodename;
var newVoucher_No;
var globalTotalAmount = 0.0;
var globalBalanceAmount = 0.00;
var glo
var GroupCode = ""
var GroupName = ""
var TDSAcCode = ''
var lblTDSAc_Name = ''

//Common table Heading style
const headerCellStyle = {
  fontWeight: "bold",
  backgroundColor: "#3f51b5",
  color: "white",
  padding: "6px",
  "&:hover": {
    backgroundColor: "#303f9f",
    cursor: "pointer",
  },
};

const MultpleRecieptPayment = () => {
  //GET Values from session
  const companyCode = sessionStorage.getItem("Company_Code");
  const YearCode = sessionStorage.getItem("Year_Code");
  const username = sessionStorage.getItem("username");
  const Post_Date = sessionStorage.getItem("Post_Date")
  const User_Id = sessionStorage.getItem("User_ID");

  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMode, setPopupMode] = useState("add");
  const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
  const [editButtonEnabled, setEditButtonEnabled] = useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
  const [backButtonEnabled, setBackButtonEnabled] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [highlightedButton, setHighlightedButton] = useState(null);
  const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [accountCode, setAccountCode] = useState("");
  const [cashbankcode, setcashbankcode] = useState("");
  const [cashbankcodeid, setcashbankcodeid] = useState("");
  const [Creditcodecode, setCreditcodecode] = useState("");
  const [Creditcodecodeid, setCreditcodecodeid] = useState("");
  const [Creditcodecodename, setCreditcodecodename] = useState("");

  const [unitcodestate, setunitcodestate] = useState("");
  const [unitcodestateid, setunitcodestateid] = useState("");
  const [unitcodestatename, setunitcodestatename] = useState("");

  const [AcadjAccodenamecode, setAcadjAccodenamecode] = useState("");
  const [AcadjAccodenameid, setAcadjAccodenameid] = useState("");
  const [AcadjAccodenamename, setAcadjAccodenamename] = useState("");

  const [groupCode, setGroupCode] = useState('');
  const [gcId, setGCID] = useState('');
  const [groupName, setGroupName] = useState('');

  const [TDS_Ac, setTDSAc] = useState('');
  const [TDSAccoid, setTDSAccoid] = useState('');
  const [TDSAcName, setTDSAcName] = useState('');

  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [users, setUsers] = useState([]);
  let [TyanTypeState, setTyanTypeState] = useState("");
  const [secondSelectOptions, setSecondSelectOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("AB");
  const [VoucherNoState, setVoucherNoState] = useState("");
  const [tenderDetails, setTenderDetails] = useState({});
  const [lastTenderDetails, setLastTenderDetails] = useState([]);
  const [lastTenderData, setLastTenderData] = useState({});
  const [cashBankBalance, setCashBankBalance] = useState(0);
  const [accountBalance, setAccountBalance] = useState(0);
  const [voucherData, setVoucherData] = useState(null);

  const inputRef = useRef(null);

  const addButtonRef = useRef(null);
  const firstInputRef = useRef(null);

  const [amountInWords, setAmountInWords] = useState('');

  //SET focus to first input feild
  const setFocusToFirstField = () => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
      setAmountInWords('')
    }
  };

  //Navigation state
  const navigate = useNavigate();
  const location = useLocation();

  //Record Double Click
  const selectedRecord = location.state?.selectedRecord;
  const tranType = location.state?.tranType;
  const permissions = location.state?.permissionsData;

  const searchParams = new URLSearchParams(location.search);
  const navigatedRecord = searchParams.get('navigatedRecord');
  const navigatedTranType = searchParams.get('navigatedTranType');


  const options = {

  };

  const validateNumericInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.-]/g, "");
  };

  const initialFormData = {
    Tran_Type: tranType ? tranType : "AB",
    DOC_NO: "",
    Doc_Date: new Date().toISOString().split("T")[0],
    Bank_Code: 0,
    Ac_Code: 0,
    ac: 0,
    Amount: 0,
    Company_Code: companyCode,
    Year_Code: YearCode,
    bc: 0,
    narration: "",
    Created_By: "",
    Modified_By: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const [formDataDetail, setFormDataDetail] = useState({
    Tran_Type: "AB",
    DOC_NO: 0,
    mr_no: 0,
    detail_Id: 0,
    mrd_no: 0,
    Bill_No: 0,
    Bill_Tran_Type: "",
    Bill_Tran_Date: new Date().toISOString().split("T")[0],
    Party_Code: 0,
    pc: 0,
    Unit_code: 0,
    uc: 0,
    Mill_Code: 0,
    mc: 0,
    Quntal: 0.00,
    Bill_Amount: 0.00,
    Bill_Receipt: 0.00,
    Bill_Balance: 0.00,
    Value: 0.00,
    Adj_Value: 0.00,
    Narration: "",
    Bill_Year_Code: 0,
    Bill_Auto_Id: 0,
    Year_Code: 0,
    Doc_Date: new Date().toISOString().split("T")[0],
    bill_comp_code: 0,
    OnAc: 0.00,
    AcadjAmt: 0.00,
    AcAdjAc: 0,
    LorryNo: "",
    Company_Code: 0,

  });

  //record lock-unlock
  const { isRecordLockedByUser, lockRecord, unlockRecord } = useRecordLocking(
    formData.DOC_NO,
    formData.Tran_Type,
    companyCode,
    YearCode,
    "Multiplereceipt_payment"
  );
  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    if (isNaN(d)) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };
  //state management for user input
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "Amount") {

      const convertedAmountInWords = ConvertNumberToWord(value);
      setAmountInWords(convertedAmountInWords);
      let updatedUsers = users;
      //globalTotalAmount=value;
      const totalItemAmount = updatedUsers.reduce((total, user) => {
        return total + parseFloat(user.Value);
      }, 0);
      const totalAdjAmtAmount = updatedUsers.reduce((total, user) => {
        return total + (parseFloat(user.Adj_Value) || 0);
      }, 0);

      const totalOnAcAmount = updatedUsers.reduce((total, user) => {
        return total + (parseFloat(user.OnAc) || 0);
      }, 0);

      const calculateTotalAmout = (totalItemAmount + totalOnAcAmount) + totalAdjAmtAmount;

      globalTotalAmount = totalItemAmount.toFixed(2);
      globalBalanceAmount = (parseFloat(value || 0) - calculateTotalAmout).toFixed(2);

    }


    setFormData((prevState) => {
      const updatedFormData = { ...prevState, [name]: value };
      return updatedFormData;
    });
  };

  const handleCashBank = async (code, accoid) => {
    if (!code) {
      setcashbankcode("");
      setcashbankcodeid("");
      setCashBankBalance(0);
      return
    }
    setcashbankcode(code);
    setcashbankcodeid(accoid);
    setFormData({
      ...formData,
      Bank_Code: code,
      bc: accoid,
    });
    const { balance, gstNo } = await fetchAccountBalance(code);
    if (balance !== null) {
      setCashBankBalance(balance)
    }
  };

  const handleAcadjAccodename = (code, accoid, name) => {
    setAcadjAccodenamecode(code);
    setAcadjAccodenameid(accoid);
    setAcadjAccodenamename(name);
  };


  const handleTDSAc = (code, accoid, name) => {
    setTDSAc(code);
    setTDSAccoid(accoid);
    setTDSAcName(name);
  };

  const handleUnitCode = (code, accoid, name) => {
    setunitcodestate(code);
    setunitcodestateid(accoid);
    setunitcodestatename(name);
  };

  const handleAccode = async (code, accoid, name) => {
    if (!code) {
      setCreditcodecode("");
      setCreditcodecodeid("");
      setCreditcodecodename("");
      setAccountBalance(0);
      return
    }
    setCreditcodecode(code);
    setCreditcodecodeid(accoid);
    setCreditcodecodename(name);
    setFormData((prevData) => ({
      ...prevData,
      Ac_Code: code,
      ac: accoid
    }));

    const { balance, gstNo } = await fetchAccountBalance(code);
    if (balance !== null) {
      setAccountBalance(balance);
    }
  };

  const handleGroupCode = (code, accoid, HSN, name) => {
    setGroupCode(code);
    setGCID(accoid);
    setGroupName(name)
  };

  const handleDropdownvalueChange = (event) => {
    const { name, value } = event.target;
    setFormDataDetail((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //GET Last record from the database
  const fetchLastRecord = () => {
    fetch(
      `${API_URL}/get_next_MultiplepaymentRecord_docNo?Company_Code=${companyCode}&tran_type=${formData.Tran_Type || tranType
      }&Year_Code=${YearCode}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch last record");
        }
        return response.json();
      })
      .then((data) => {
        setFormData((prevState) => ({
          ...prevState,
          DOC_NO: data.next_doc_no,
        }));
      })
      .catch((error) => {
        console.error("Error fetching last record:", error);
      });
  };


  const handleDetailDropdownChange = (selectedValue) => {
    updateSecondSelect(selectedValue);
  };

  const updateSecondSelect = (selectedValue) => {
    setSelectedCategory(selectedValue);
    setSecondSelectOptions(options[selectedValue] || []);
  };

  const handleDropdownChange = async (event) => {
    const selectedValue = event.target.value;

    setTyanTypeState(selectedValue);
    setFormData((prevData) => ({
      ...prevData,
      tran_type: selectedValue,
    }));

    const url = `${API_URL}/get-lastMultiplereceiptpayment-navigation?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${selectedValue}`;
    await handleNavigation(url, "last_head_data", "last_details_data");
  };

  const handleAddOne = async () => {
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setIsEditing(true);
    fetchLastRecord();
    setFormData(initialFormData);
    setLastTenderDetails([]);
    setAccountBalance(0)
    setCashBankBalance(0)
    globalTotalAmount = "";
    lblbankname = "";
    newcashbank = "";
    newcredit_ac = "";
    lblacname = "";
    newUnitCode = "";
    lblUnitname = "";
    newAcadjAccode = "";
    lblAcadjAccodename = "";
    TDSAcCode = '';
    lblTDSAc_Name = ''
    setCreditcodecodename("");
    setTDSAcName("");
    GroupName = "";
    GroupCode = "";

    const effectiveTranType = tranType || TyanTypeState || formData.Tran_Type;
    setFormData((prevData) => ({
      ...prevData,
      Tran_Type: effectiveTranType
    }));
    handleDetailDropdownChange(effectiveTranType);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  //Handle Save Or Update the information
  const handleSaveOrUpdate = async () => {
    debugger;
    const Post_Date = sessionStorage.getItem("Post_Date")
    if (await PostDateRecordLock(formData.Doc_Date, Post_Date)) {
      return;
    }

    const accountingYearData = sessionStorage.getItem('Accounting_Year');
    const formattedEntryDate = formData.Doc_Date;
    const isValid = validateDocumentDate(formattedEntryDate, accountingYearData);

    if (!isValid) {
      return
    }

    if (parseFloat(globalBalanceAmount) !== 0) {
      await Swal.fire({
        title: "Error",
        text: "Balance Must Zero",
        icon: "error",
        confirmButtonText: "OK"
      });
      return;
    }

    if (formData.Bank_Code === "" || formData.Bank_Code === 0) {
      await Swal.fire({
        title: "Error",
        text: "Please select Cash/Bank",
        icon: "error",
        confirmButtonText: "OK"
      });
      return;
    }

    // Check if there are any valid entries in the detail grid
    if (users.length === 0 || users.every(user => user.rowaction === "DNU" || user.rowaction === "delete")) {
      await Swal.fire({
        title: "Error",
        text: "Please add at least one entry in the detail grid.",
        icon: "error",
        confirmButtonText: "OK"
      });
      return;
    }

    setIsLoading(true);
    try {
      let head_data = { ...formData };
      if (isEditMode) {
        head_data = {
          ...head_data,
          Modified_By: username,
          User_Id: User_Id
        };
      } else {
        head_data = {
          ...head_data,
          Created_By: username,
        };
      }
      const detail_data = users
        .filter(user => (parseFloat(user.Value) || 0) !== 0 || (parseFloat(user.OnAc) || 0) !== 0)
        .map((user) => ({
          rowaction: "ADD",
          Tran_Type: formData.Tran_Type,

          detail_Id: user.detail_Id,

          Bill_No: user.Bill_No,
          Bill_Tran_Type: user.Bill_Tran_Type,
          Bill_Tran_Date: user.Bill_Tran_Date ? formatDate(user.Bill_Tran_Date) : null,
          Party_Code: user.Party_Code,
          pc: user.pc,
          Unit_code: user.Unit_code,
          uc: user.uc,
          Mill_Code: user.Mill_Code,
          mc: user.mc,
          Quntal: user.Quntal,
          Bill_Amount: user.Bill_Amount,
          Bill_Receipt: user.Bill_Receipt,
          Bill_Balance: user.Bill_Balance,
          Value: user.Value,
          Adj_Value: user.Adj_Value,
          Narration: user.Narration,
          Bill_Year_Code: user.Bill_Year_Code,
          Bill_Auto_Id: user.Bill_Auto_Id,
          Year_Code: YearCode,
          Doc_Date: formData.Doc_Date,
          bill_comp_code: user.bill_comp_code,
          OnAc: user.OnAc,
          AcadjAmt: user.AcadjAmt,
          AcAdjAc: user.AcAdjAc,
          LorryNo: user.LorryNo,
          Company_Code: companyCode,
          mr_no: head_data.mr_no,
        }));

      const requestData = {
        head_data: {
          ...head_data,
          mr_no: isEditMode ? undefined : head_data.mr_no,
        },
        detail_data,
      };

      const apiUrl = isEditMode
        ? `${API_URL}/update-Multiplereceiptpayment?tranid=${formData.mr_no}`
        : `${API_URL}/insert-Multiplereceiptpayment`;

      const response = await axios[isEditMode ? "put" : "post"](
        apiUrl,
        requestData
      );

      if (response.status === 200 || response.status === 201) {

        const successMessage = isEditMode
          ? "Record updated successfully!"
          : "Record created successfully!";

        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: successMessage,
        });
        unlockRecord();
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setUpdateButtonClicked(true);
        setIsEditing(false);

      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      navigate(`/MultipleReciept-Payment?navigatedRecord=${formData.DOC_NO}&navigatedTranType=${formData.Tran_Type || tranType}`);
    } catch (error) {
      console.error("Error saving or updating data:", error);
      toast.error("An error occurred while saving or updating data.");
    } finally {
      setIsLoading(false);
    }
  };


  //Handle Edit the information
  const handleEdit = async () => {
    const Post_Date = sessionStorage.getItem("Post_Date")
    if (await PostDateRecordLock(formData.Doc_Date, Post_Date)) {
      return;
    }
    axios
      .get(
        `${API_URL}/getMultiplereceiptpaymentByid?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}&doc_no=${formData.DOC_NO}`
      )
      .then((response) => {
        const data = response.data;
        const isLockedNew = data.receipt_payment_head.LockedRecord;
        const isLockedByUserNew = data.receipt_payment_head.LockedUser;
        if (isLockedNew) {
          Swal.fire({
            icon: "warning",
            title: "Record Locked",
            text: `This record is locked by ${isLockedByUserNew}`,
            confirmButtonColor: "#d33",
          });
          return;
        } else {
          lockRecord();
        }
        setFormData({
          ...formData,
          ...data.receipt_payment_head,
        });

        setIsEditMode(true);
        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setBackButtonEnabled(true);
        setIsEditing(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //Handle Cancel the information
  const handleCancel = async () => {
    const url = `${API_URL}/get-lastMultiplereceiptpayment-navigation?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type || tranType
      }`;
    await handleNavigation(url, "last_head_data", "last_details_data");
    unlockRecord();
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
  };

  //Handle Delete the information
  // const handleDelete = async () => {
  //   const Post_Date = sessionStorage.getItem("Post_Date")
  //   if (await PostDateRecordLock(formData.Doc_Date, Post_Date)) {
  //     return;
  //   }
  //   try {
  //     const response = await axios.delete(`${API_URL}/delete_data_by_tranid_MultipleReciept`, {
  //       params: {
  //         Company_Code: companyCode,
  //         Year_Code: YearCode,
  //         tran_type: formData.Tran_Type,
  //         DOC_NO: formData.DOC_NO,
  //         tranid: formData.mr_no
  //       },
  //     });
  //     const data = response.data;
  //     const isLockedNew = data.receipt_payment_head.LockedRecord;
  //     const isLockedByUserNew = data.receipt_payment_head.LockedUser;

  //     if (isLockedNew) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Record Locked",
  //         text: `This record is locked by ${isLockedByUserNew}`,
  //         confirmButtonColor: "#d33",
  //       });
  //       return;
  //     }

  //     const result = await Swal.fire({
  //       title: "Are you sure?",
  //       text: `You won't be able to revert this Doc No : ${formData.DOC_NO}`,
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#d33",
  //       cancelButtonColor: "#3085d6",
  //       cancelButtonText: "Cancel",
  //       confirmButtonText: "Delete",
  //       reverseButtons: true,
  //       focusCancel: true,
  //     });


  //     if (result.isConfirmed) {
  //       setIsEditMode(false);
  //       setAddOneButtonEnabled(true);
  //       setEditButtonEnabled(true);
  //       setDeleteButtonEnabled(true);
  //       setBackButtonEnabled(true);
  //       setSaveButtonEnabled(false);
  //       setCancelButtonEnabled(false);
  //       setIsLoading(true);

  //       try {
  //         const deleteApiUrl = `${API_URL}/delete_data_by_tranid_MultipleReciept`;
  //         const deleteResponse = await axios.delete(deleteApiUrl, {
  //           params: {
  //             tranid: formData.tranid,
  //             company_code: companyCode,
  //             year_code: YearCode,
  //             DOC_NO: formData.DOC_NO,
  //             Tran_Type: formData.Tran_Type || tranType,
  //             user_id: User_Id,
  //           },
  //         });
  //         Swal.fire({
  //           title: "Deleted!",
  //           text: "Record deleted successfully!",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //         });
  //         handleCancel();
  //       } catch (error) {
  //         toast.error("Deletion failed.");
  //         console.error("Error during API call:", error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     } else {
  //       Swal.fire({
  //         title: "Cancelled",
  //         text: "Your record is safe 🙂",
  //         icon: "info",
  //       });
  //     }
  //   } catch (error) {
  //     toast.error("Error fetching data.");
  //   }
  // };


  const handleDelete = async (user) => {
    debugger
    // const Post_Date = sessionStorage.getItem("Post_Date")
    // if (await PostDateRecordLock(formData.Doc_Date, Post_Date)) {
    //   return;
    // }


    try {
      const response = await axios.get(
        `${API_URL}/getMultiplereceiptpaymentByid?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}&doc_no=${formData.DOC_NO}`
      );

      const data = response.data;
      // const isLockedNew = data.last_head_data.LockedRecord;
      // const isLockedByUserNew = data.last_head_data.LockedUser;

      // if (isLockedNew) {
      //   Swal.fire({
      //     title: "Record Locked",
      //     text: `This record is locked by ${isLockedByUserNew}`,
      //     icon: "warning",
      //     confirmButtonText: "OK",
      //   });
      //   return;
      // }

      const result = await Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to delete this Doc No: ${formData.DOC_NO}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: "Cancel",
        confirmButtonText: "Delete",
        reverseButtons: true,
        focusCancel: true,
      });

      if (result.isConfirmed) {
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setIsLoading(true);

        const deleteApiUrl = `${API_URL}/delete_data_by_tranid_MultipleReciept`;
        const deleteResponse = await axios.delete(deleteApiUrl, {
          params: {
            tranid: formData.mr_no,
            Company_Code: companyCode,
            Year_Code: YearCode,
            DOC_NO: formData.DOC_NO,
            tran_type: formData.Tran_Type || tranType,
          },
        });

        if (deleteResponse.status === 200) {
          if (deleteResponse.data) {
            Swal.fire({
              title: "Deleted!",
              text: "Data deleted successfully!",
              icon: "success",
              confirmButtonText: "OK",
            });
            handleCancel();
          }
          const docNoNum = parseInt(formData.DOC_NO);
          if (!docNoNum || docNoNum <= 1) {
            handleAddOne();
          } else {

            handleCancel();
          }
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to delete the record.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your record is safe 🙂",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error during API call:", error);
      Swal.fire({
        title: "Error",
        text: `There was an error during the deletion: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  //hand back to Dashboard
  const handleBack = () => {
    navigate("/MultipleRecieptPaymentUtility");
  };

  useEffect(() => {
    if (selectedRecord) {
      handleRecordDoubleClicked();
    }
    else if (navigatedRecord && !isNaN(navigatedRecord) && parseInt(navigatedRecord) > 0) {
      handleNavigateRecord();
    }
    else {
      handleAddOne();
    }
  }, [selectedRecord, navigatedRecord]);

  const handleKeyDownCalculations = (e) => {
    if (e.key !== "Tab") return;

    const amount = parseFloat(formDataDetail.Value) || 0;
    const adjusted = parseFloat(formDataDetail.Adj_Value) || 0;
    const base = amount + adjusted;

  };

  useEffect(() => {
    if (selectedRecord) {
      setUsers(
        lastTenderDetails.map((detail) => ({
          rowaction: "Normal",
          Tran_Type: formData.Tran_Type,
          detail_Id: detail.detail_Id,

          Bill_No: detail.Bill_No,
          Bill_Tran_Type: detail.Bill_Tran_Type,
          Bill_Tran_Date: detail.Bill_Tran_Date,
          Party_Code: detail.Party_Code,
          pc: detail.pc,
          Unit_code: detail.Unit_code,
          uc: detail.uc,
          Mill_Code: detail.Mill_Code,
          mc: detail.mc,
          Quntal: detail.Quntal,
          Bill_Amount: detail.Bill_Amount,
          Bill_Receipt: detail.Bill_Receipt,
          Bill_Balance: detail.Bill_Balance,
          Value: detail.Value,
          Adj_Value: detail.Adj_Value,
          Narration: detail.narration,
          Bill_Year_Code: detail.Bill_Year_Code,
          Bill_Auto_Id: detail.Bill_Balance,
          Year_Code: YearCode,
          Doc_Date: formData.Doc_Date,
          bill_comp_code: detail.bill_comp_code,
          OnAc: detail.OnAc,
          AcadjAmt: detail.AcadjAmt,
          AcAdjAc: detail.AcAdjAc,
          LorryNo: detail.LorryNo,
          Company_Code: companyCode,
        }))
      );
    }
  }, [selectedRecord, lastTenderDetails]);

  useEffect(() => {
    setUsers(
      lastTenderDetails.map((detail) => ({
        rowaction: "Normal",
        Tran_Type: formData.Tran_Type,
        detail_Id: detail.detail_Id,
        Bill_No: detail.Bill_No,
        Bill_Tran_Type: detail.Bill_Tran_Type,
        Bill_Tran_Date: detail.Bill_Tran_Date,
        Party_Code: detail.Party_Code,
        partyname: detail.partyname,
        pc: detail.pc,
        Unit_code: detail.Unit_code,
        uc: detail.uc,
        Mill_Code: detail.Mill_Code,
        mc: detail.mc,
        Quntal: detail.Quntal,
        Bill_Amount: detail.Bill_Amount,
        Bill_Receipt: detail.Bill_Receipt,
        Bill_Balance: detail.Bill_Balance,
        Value: detail.Value,
        Adj_Value: detail.Adj_Value,
        Narration: detail.narration,
        Bill_Year_Code: detail.Bill_Year_Code,
        Bill_Auto_Id: detail.Bill_Auto_Id,
        Year_Code: YearCode,
        Doc_Date: formData.Doc_Date,
        bill_comp_code: detail.bill_comp_code,
        OnAc: detail.OnAc,
        AcadjAmt: detail.AcadjAmt,
        AcAdjAc: detail.AcAdjAc,
        LorryNo: detail.LorryNo,
        Company_Code: companyCode,
        mrd_no: detail.mrd_no
      }))
    );
  }, [lastTenderDetails]);


  const handleNavigation = async (url, headKey, detailsKey) => {
    try {
      debugger;

      const response = await fetch(url);

      if (response.ok) {

        debugger
        const data = await response.json();
        const { labels, [headKey]: headData, [detailsKey]: detailsData } = data;

        const DetailsArray = Array.isArray(detailsData) ? detailsData : [];
        setCreditcodecode(headData?.Ac_Code);
        setCreditcodecodename(labels[0]?.creditacname);
        // Label assignments for top-level fields
        lblbankname = labels[0]?.bank_name || "";
        newcashbank = headData?.Bank_Code || "";

        lblacname = labels[0]?.creditacname || "";
        newcredit_ac = headData?.Ac_Code || "";

        // Safer key mapping by prefixing field type to avoid clashes
        const itemNameMap = labels.reduce((map, label) => {
          if (label.Party_Code !== undefined && label.creditacname) {
            map[`Party_Code${label.Party_Code}`] = label.creditacname;
          }

          return map;
        }, {});
        debugger;

        // Enrich details with the correct scoped mappings
        const enrichedDetails = DetailsArray.map((detail) => ({
          ...detail,

          partyname: itemNameMap[`Party_Code${detail.Party_Code}`] || "",
          unitname: itemNameMap[`unit_${detail.Unit_Code}`] || "",
          millname: itemNameMap[`adjusted_${detail.Mill_Code}`] || "",
          Doc_Date: formatDate(detail.Doc_Date),
          Bill_Tran_Date: formatDate(detail.Bill_Tran_Date),
          Bill_Receipt: detail.Value,
          //Bill_Balance :detail.Bill_Balance,

        }));

        const totalItemAmount = enrichedDetails.reduce(
          (total, user) => total + parseFloat(user.Value || 0),
          0
        );
        globalTotalAmount = totalItemAmount.toFixed(2);

        setFormData((prevData) => ({
          ...prevData,
          ...headData,
          //   total: globalTotalAmount,
        }));

        setLastTenderData(headData || {});
        console.log("enrichedDetails", enrichedDetails)
        setLastTenderDetails(enrichedDetails);
      } else {
        console.error(
          `Failed to fetch data: ${response.status} ${response.statusText}`
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  // Function to handle the double-click action
  const handleRecordDoubleClicked = async () => {
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);

    const url = `${API_URL}/getMultiplereceiptpaymentByid?Company_Code=${companyCode}&tranid=${selectedRecord.mr_no}&tran_type=${selectedRecord.Tran_Type}&doc_no=${selectedRecord.DOC_NO}&Year_Code=${YearCode}`;

    await handleNavigation(
      url,
      "receipt_payment_head",
      "receipt_payment_details"
    );
  };

  // Navigation Button Handlers
  const handleFirstButtonClick = async () => {
    const url = `${API_URL}/get-firstMultiplereceiptpayment-navigation?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}`;
    await handleNavigation(url, "first_head_data", "first_details_data");
  };

  const handlePreviousButtonClick = async () => {
    const url = `${API_URL}/get-previousMultiplereceiptpayment-navigation?currentDocNo=${formData.DOC_NO}&Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}`;
    await handleNavigation(url, "previous_head_data", "previous_details_data");
  };

  const handleNextButtonClick = async () => {
    const url = `${API_URL}/get-nextMultiplereceiptpayment-navigation?currentDocNo=${formData.DOC_NO}&Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}`;
    await handleNavigation(url, "next_head_data", "next_details_data");
  };

  const handleLastButtonClick = async () => {
    const url = `${API_URL}/get-lastMultiplereceiptpayment-navigation?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}`;
    await handleNavigation(url, "last_head_data", "last_details_data");
  };

  // Tab Key Down Handler
  const handleKeyDown = async (event) => {
    if (event.key === "Tab") {
      const changeNoValue = event.target.value;
      const url = `${API_URL}/getMultiplereceiptpaymentByid?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${formData.Tran_Type}&doc_no=${changeNoValue}`;

      await handleNavigation(
        url,
        "receipt_payment_head",
        "receipt_payment_details"
      );
    }
  };

  const handleNavigateRecord = async () => {
    const url = `${API_URL}/getMultiplereceiptpaymentByid?Company_Code=${companyCode}&Year_Code=${YearCode}&tran_type=${navigatedTranType}&doc_no=${navigatedRecord}`;
    await handleNavigation(
      url,
      "receipt_payment_head",
      "receipt_payment_details"
    );
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
  }

  //Detail Part
  const handleChangeDetail = (event) => {
    const { name, value } = event.target;
    let updatedFormDataDetail = { ...formDataDetail, [name]: value };

    if (name === 'Amount') {
      const convertedAmountInWords = ConvertNumberToWord(value);
      setAmountInWords(convertedAmountInWords);
    }

    setFormDataDetail(updatedFormDataDetail);
  };


  const openPopup = (mode) => {
    setShowPopup(true);
    const selectedValue = formData.Tran_Type || tranType;

    handleDetailDropdownChange(selectedValue);
    if (mode === "add") {
      clearForm();
    }
  };

  const clearForm = () => {
    setFormDataDetail({
      Tran_Type: "",
      DOC_NO: 0,
      mr_no: 0,
      detail_Id: 0,
      mrd_no: 0,
      Bill_No: 0,
      Bill_Tran_Type: "",
      Bill_Tran_Date: "",
      Party_Code: 0,
      pc: 0,
      Unit_code: 0,
      uc: 0,
      Mill_Code: 0,
      mc: 0,
      Quntal: 0.00,
      Bill_Amount: 0.00,
      Bill_Receipt: 0.00,
      Bill_Balance: 0.00,
      Value: 0.00,
      Adj_Value: 0.00,
      Narration: "",
      Bill_Year_Code: 0,
      Bill_Auto_Id: 0,
      Year_Code: 0,
      Doc_Date: "",
      bill_comp_code: 0,
      OnAc: 0.00,
      AcadjAmt: 0.00,
      AcAdjAc: 0,
      LorryNo: "",
      Company_Code: 0,
    });

    setCreditcodecode("");

    setCreditcodecodename("");

    setAccountBalance(0)
    setCashBankBalance(0)

  };


  //close popup function
  const closePopup = () => {
    setShowPopup(false);
    setSelectedUser({});
    clearForm();
    setAmountInWords('')
  };

  //   const handleRecieptvoucher = (Tenderno) => {
  //     setVoucherNoState(Tenderno);
  //     setFormDataDetail({
  //       ...formDataDetail,
  //       Voucher_No: Tenderno,
  //     });
  //   };

  //   const handleTenderDetailsFetched = (details) => {
  //     debugger
  //     if (!details?.last_details_data || !details.last_details_data.length) {
  //       console.error("No last_details_data found in details:", details);
  //       return;
  //     }

  //     const last = details.last_details_data[0];

  //     setTenderDetails(last);

  //     setFormDataDetail((prevState) => ({
  //       ...prevState,
  //       Voucher_Type: last.Tran_Type,
  //       tenderdetailid: last.autoId,
  //       amount: last.Bill_Amount,
  //       narration: last.Narration,
  //       YearCodeDetail: last.EntryYearCode,
  //       Tran_Type: TyanTypeState || tranType || prevState.Tran_Type,
  //       debit_ac: formData.cashbank || prevState.debit_ac,
  //       da: formData.ca || prevState.da,
  //     }));

  //     return {
  //       Voucher_Type: last.Tran_Type,
  //       tenderdetailid: last.autoId,
  //       amount: last.Bill_Amount,
  //       narration: last.Narration,
  //       YearCodeDetail: last.EntryYearCode,
  //     };
  //   };

  const handleInputChange = (index, field, value) => {
    const updatedUsers = [...users];

    updatedUsers[index][field] = value;

    if (field !== "Narration") {

      const totalItemAmount = updatedUsers.reduce((total, user) => {
        return total + (parseFloat(user.Value) || 0);
      }, 0);

      const totalAdjAmtAmount = updatedUsers.reduce((total, user) => {
        return total + (parseFloat(user.Adj_Value) || 0);
      }, 0);

      const totalOnAcAmount = updatedUsers.reduce((total, user) => {
        return total + (parseFloat(user.OnAc) || 0);
      }, 0);

      const calculateTotalAmout = (totalItemAmount + totalOnAcAmount) + totalAdjAmtAmount;


      const total = totalItemAmount.toFixed(2);

      const balance = (
        (parseFloat(formData.Amount) || 0) - calculateTotalAmout
      ).toFixed(2);

      globalTotalAmount = total;
      globalBalanceAmount = balance;
      ///setGlobalTotalAmount(total);
      //setGlobalBalanceAmount(balance);
    }

    setUsers(updatedUsers);
  };

  const handleGetVoucher = async () => {
    try {
      const userCheckUrl = `${API_URL}/GetSaleBillBalanceData?Company_Code=${companyCode}&Year_Code=${YearCode}&Tran_Type=${formData.Tran_Type}&Ac_Code=${Creditcodecode}`;

      const response = await axios.get(userCheckUrl);

      let detailData = response.data.all_data; // this is array

      setVoucherData(detailData);
      debugger;
      const newUsers = detailData.map((item) => ({
        rowaction: "ADD",
        detail_Id: item.Detail_Id,
        Bill_No: item.doc_no,
        Bill_Tran_Type: item.tran_type,
        Bill_Tran_Date: item.Doc_date,
        Party_Code: item.Party_Code,
        partyname: item.PartyName,
        pc: item.ac,
        Unit_code: item.Unit_Code,
        unitname: item.Unit_Name,
        uc: item.uc,
        Mill_Code: item.Mill_Code,
        millname: item.Mill_Short,
        mc: item.mc,
        Quntal: item.NETQNTL,
        Bill_Amount: item.Bill_Amount,
        Bill_Receipt: item.Paid_Amount,
        Bill_Balance: item.Balance,
        Value: item.Amount,
        Adj_Value: item.Adjusted_Amount,
        Narration: item.Narration,
        Bill_Year_Code: item.EntryYearCode,
        Bill_Auto_Id: item.saleid,
        bill_comp_code: item.BillCompany,
        OnAc: item.OnAc,
        AcadjAmt: 0,
        AcAdjAc: 0,
        LorryNo: item.LorryNo,
      }));

      // setUsers((prev) => {
      //   const merged = [...prev];

      //   newUsers.forEach((newRow) => {
      //     const index = merged.findIndex(
      //       (row) =>
      //         row.Bill_No === newRow.Bill_No &&
      //         row.Bill_Tran_Type === newRow.Bill_Tran_Type
      //     );

      //     if (index !== -1) {
      //       // If row exists → update it
      //      // merged[index] = { ...merged[index], ...newRow };
      //       merged[index] = {
      //   ...merged[index],
      //   ...newRow,
      //   Value: Number(newRow.Value)
      //     }
      //    } else {
      //       // If row does not exist → add it
      //       merged.push({
      //   ...newRow,
      //   Value: Number(newRow.Value)
      // });
      //     }
      //   });

      //   return merged;
      // });
      setUsers((prev) => {
        const map = new Map();

        prev.forEach((row) => map.set(row.Bill_No + row.Bill_Tran_Type, row));

        newUsers.forEach((row) =>
          map.set(row.Bill_No + row.Bill_Tran_Type, { ...row, Value: Number(row.Value) || 0 })
        );

        return Array.from(map.values());
      });

    } catch (error) {
      console.error("Error fetching voucher:", error);
    }
  };
  const [remainingAmount, setRemainingAmount] = useState(0);

  useEffect(() => {
    setRemainingAmount(parseFloat(formData.Amount || 0));
  }, [formData.Amount]);



  // const handleCheckboxChange = (index, checked) => {
  //   let updatedUsers = [...users];

  //   // Update only clicked checkbox
  //   updatedUsers[index].isSelected = checked;

  //   let tempRemaining = parseFloat(formData.Amount || 0);

  //   updatedUsers.forEach((item) => {
  //     item.Value = "";
  //   });


  //   for (let i = 0; i < updatedUsers.length; i++) {
  //     if (updatedUsers[i].isSelected && tempRemaining > 0) {
  //       const balance = parseFloat(updatedUsers[i].Bill_Balance || 0);

  //       if (tempRemaining >= balance) {
  //         updatedUsers[i].Value = balance;
  //         tempRemaining -= balance;
  //       } else {
  //         updatedUsers[i].Value = tempRemaining;
  //         tempRemaining = 0;
  //       }
  //     }
  //   }

  //   setUsers(updatedUsers);


  //   const totalItemAmount = updatedUsers.reduce((total, user) => {
  //     return total + (parseFloat(user.Value) || 0);
  //   }, 0);

  //   const totalAdjAmtAmount = updatedUsers.reduce((total, user) => {
  //     return total + (parseFloat(user.Adj_Value) || 0);
  //   }, 0);

  //   const totalOnAcAmount = updatedUsers.reduce((total, user) => {
  //     return total + (parseFloat(user.OnAc) || 0);
  //   }, 0);

  //   const calculateTotalAmout =
  //     totalItemAmount + totalOnAcAmount + totalAdjAmtAmount;

  //   globalTotalAmount = totalItemAmount.toFixed(2);

  //   globalBalanceAmount = (
  //     parseFloat(formData.Amount || 0) - calculateTotalAmout
  //   ).toFixed(2);
  // };


  const handleCheckboxChange = (index, checked) => {
    let updatedUsers = [...users];

    updatedUsers[index].isSelected = checked;

  
    if (checked) {
      updatedUsers[index].selectedOrder = Date.now(); 
    } else {
      updatedUsers[index].selectedOrder = null;
    }

    let tempRemaining = parseFloat(formData.Amount || 0);

   
    updatedUsers.forEach((item) => {
      item.Value = "";
    });

    
    const selectedRows = updatedUsers
      .filter((item) => item.isSelected)
      .sort((a, b) => a.selectedOrder - b.selectedOrder);

    selectedRows.forEach((item) => {
      if (tempRemaining > 0) {
        const balance = parseFloat(item.Bill_Balance || 0);

        if (tempRemaining >= balance) {
          item.Value = balance;
          tempRemaining -= balance;
        } else {
          item.Value = tempRemaining;
          tempRemaining = 0;
        }
      }
    });

    setUsers(updatedUsers);

   
    const totalItemAmount = updatedUsers.reduce((total, user) => {
      return total + (parseFloat(user.Value) || 0);
    }, 0);

    const totalAdjAmtAmount = updatedUsers.reduce((total, user) => {
      return total + (parseFloat(user.Adj_Value) || 0);
    }, 0);

    const totalOnAcAmount = updatedUsers.reduce((total, user) => {
      return total + (parseFloat(user.OnAc) || 0);
    }, 0);

    const calculateTotalAmout =
      totalItemAmount + totalOnAcAmount + totalAdjAmtAmount;

    globalTotalAmount = totalItemAmount.toFixed(2);

    globalBalanceAmount = (
      parseFloat(formData.Amount || 0) - calculateTotalAmout
    ).toFixed(2);
  };


  return (
    <>
      <UserAuditInfo
        createdBy={formData.Created_By}
        modifiedBy={formData.Modified_By}
        title={"Multiple Receipt Payment"}
      />
      <div>
        <ToastContainer autoClose={500} />
        <br></br>
        <ActionButtonGroup
          handleAddOne={handleAddOne}
          addOneButtonEnabled={addOneButtonEnabled}
          handleSaveOrUpdate={handleSaveOrUpdate}
          saveButtonEnabled={saveButtonEnabled}
          isEditMode={isEditMode}
          handleEdit={handleEdit}
          editButtonEnabled={editButtonEnabled}
          handleDelete={handleDelete}
          deleteButtonEnabled={deleteButtonEnabled}
          handleCancel={handleCancel}
          cancelButtonEnabled={cancelButtonEnabled}
          handleBack={handleBack}
          backButtonEnabled={backButtonEnabled}
          permissions={permissions}
        // component={<RecieptPaymentReport doc_no={formData.doc_no} Tran_Type={formData.Tran_Type} disabledFeild={!addOneButtonEnabled} />}
        />
        <div>
          <NavigationButtons
            handleFirstButtonClick={handleFirstButtonClick}
            handlePreviousButtonClick={handlePreviousButtonClick}
            handleNextButtonClick={handleNextButtonClick}
            handleLastButtonClick={handleLastButtonClick}
            highlightedButton={highlightedButton}
            isEditing={isEditing}
            isFirstRecord={formData.Company_Code === companyCode}
          />
        </div>
      </div>
      <div>
        <form>
          <Grid
            container
            spacing={1}
            alignItems="center"
            sx={{ justifyContent: "flex-start" }}
            mt={0.5}
          >
            <Grid item xs={12} sm={1} sx={{ textAlign: "left" }}>
              <TextField
                label="Change No"
                id="changeNo"
                name="changeNo"
                autoComplete="off"
                onKeyDown={handleKeyDown}
                disabled={!addOneButtonEnabled}
                size="small"
                InputLabelProps={{
                  shrink: true,
                  style: { fontWeight: 'bold' },
                }}
              />
            </Grid>

            <div className="w-full sm:w-[10%] ml-1 mt-1">
              <select
                id="tran_type"
                name="tran_type"
                value={formData.Tran_Type}
                onChange={handleDropdownChange}
                disabled={!addOneButtonEnabled}
                className="w-full h-10 px-3 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <option value="AB">Against Bill</option>
                <option value="AS">Against Sauda</option>
                <option value="AF">Bank Reciept Against Freight(for saudawise reciept purpose only)</option>
                <option value="TP">Bank Payment Transport</option>
              </select>
            </div>




            <Grid item xs={12} sm={0.8}>
              <TextField
                label="Doc No"
                id="Doc_No"
                name="doc_no"
                value={formData.DOC_NO}
                onChange={handleChange}
                disabled={true}
                fullWidth
                size="small"
                InputLabelProps={{
                  style: { fontWeight: 'bold' },
                }}

                InputProps={{
                  style: { fontSize: '12px', height: '35px' },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={1} sx={{ padding: 0.5, minWidth: '100px', maxWidth: '100px' }}>
              <TextField
                label="Doc Date"
                id="Doc_Date"
                name="Doc_Date"
                type="date"
                value={formData.Doc_Date}
                inputRef={inputRef}
                onChange={handleChange}
                disabled={!isEditing && addOneButtonEnabled}
                fullWidth
                InputLabelProps={{
                  style: { fontSize: '12px' },
                }}
                InputProps={{
                  style: { fontSize: '12px', height: '35px' },
                }}
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box display="flex" alignItems="center">
                <Box flex="1" position="relative">
                  <FormControl fullWidth>
                    <InputLabel shrink style={{ fontWeight: 'bold' }}>
                      Cash/Bank
                    </InputLabel>

                    <AccountMasterHelp
                      name="Bank_Code"
                      onAcCodeClick={handleCashBank}
                      CategoryName={lblbankname}
                      CategoryCode={newcashbank}
                      Ac_type={["B", "C"]}
                      disabledFeild={!isEditing && addOneButtonEnabled}
                      size="small"
                    />
                  </FormControl>
                </Box>

                {/* BALANCE - NEAR THE FIELD */}
                {!(!isEditing && addOneButtonEnabled) && (
                  <Typography
                    sx={{
                      marginLeft: "6px",        // VERY CLOSE to input
                      whiteSpace: "nowrap",
                      fontWeight: "bold",
                      fontSize: "24px",
                      minWidth: "70px",
                      textAlign: "left",
                      color: accountBalance < 0 ? "red" : "green",
                    }}
                  >
                    ₹ {formatReadableAmount(Math.abs(cashBankBalance))}{""}
                    {/* {cashBankBalance < 0 ? "Dr" : cashBankBalance > 0 ? "Cr" : ""} */}
                  </Typography>
                )}
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box display="flex" alignItems="center">
                <Box flex="1" position="relative">
                  <FormControl fullWidth>
                    <InputLabel shrink style={{ fontWeight: 'bold' }}>
                      Party Code
                    </InputLabel>

                    <AccountMasterHelp
                      name="Ac_Code"
                      onAcCodeClick={handleAccode}
                      CategoryName={Creditcodecodename}
                      CategoryCode={Creditcodecode}
                      Ac_type={[]}
                      firstInputRef={firstInputRef}
                      disabledFeild={!isEditing && addOneButtonEnabled}
                    />
                  </FormControl>
                </Box>

                {/* BALANCE - NEAR THE FIELD */}
                {!(!isEditing && addOneButtonEnabled) && (
                  <Typography
                    sx={{
                      marginLeft: "6px",        // VERY CLOSE to input
                      whiteSpace: "nowrap",
                      fontWeight: "bold",
                      fontSize: "24px",
                      minWidth: "70px",
                      textAlign: "left",
                      color: accountBalance < 0 ? "red" : "green",
                    }}
                  >
                    ₹ {formatReadableAmount(Math.abs(accountBalance))}{""}
                    {/* {cashBankBalance < 0 ? "Dr" : cashBankBalance > 0 ? "Cr" : ""} */}
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Box display="flex" alignItems="center">
                <Box flex="1" position="relative">
                  <FormControl fullWidth>
                    <InputLabel shrink style={{ fontWeight: 'bold' }}>
                      Amount
                    </InputLabel>
                    <TextField
                      label="Amount"
                      id="Amount"
                      name="Amount"
                      value={formData.Amount}
                      onChange={handleChange}
                      disabled={!isEditing && addOneButtonEnabled}
                      fullWidth
                      size="small"
                      InputLabelProps={{
                        style: { fontWeight: 'bold' },
                      }}

                      InputProps={{
                        style: { fontSize: '15px', height: '35px' },
                      }}
                    />
                  </FormControl>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={1} sx={{ textAlign: "left" }}>
              <TextField
                label="Narration"
                id="narration"
                name="narration"
                autoComplete="off"
                value={formData.narration}
                onChange={handleChange}
                disabled={!isEditing && addOneButtonEnabled}
                multiline
                rows={2}
                sx={{
                  width: "250px",
                }}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <label
              htmlFor="narration"
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginRight: "10px",
                display: "inline-block",
              }}
            >
              Amount in Words:
            </label>
            <p style={{ marginLeft: "20px", marginTop: '20px', color: "blue", fontWeight: "bold" }}> {amountInWords}</p>
          </div>
        </form>
        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner-container">
              <SaveUpdateSpinner />
            </div>
          </div>
        )}
        <div>


          <div style={{ marginTop: "10px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {/* <AddButton  isEditing={isEditing} ref={addButtonRef} setFocusToFirstField={setFocusToFirstField}  label={"Get Voucher"}/> */}
            <button onClick={handleGetVoucher}>  Get Voucher</button>
            <Typography
              variant="h6"
              sx={{
                marginBottom: '10px',
                fontWeight: 'bold',
                fontSize: '1.25rem',
                color: '#333',
                background: 'linear-gradient(45deg, #6a11cb 0%, #2575fc 100%)',
                WebkitBackgroundClip: 'text',
                display: 'inline',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '8px 16px',
                borderRadius: '5px',
                backgroundColor: 'white',
                textAlign: 'center',
                cursor: "pointer"
              }}
            >
              Total Entries: {users.length}
            </Typography>
          </div>

          {showPopup && (
            <div className="RecieptPaymentmodal" >
              <div className="RecieptPaymentmodal-dialog" style={{
                display: "block",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: "1050",
                width: "100%",
                maxWidth: "1200px"
              }} >
                <div className="RecieptPaymentmodal-content">
                  <div className="RecieptPaymentmodal-header">
                    <h5 className="RecieptPaymentmodal-title" style={{ marginBottom: "-20px" }}>
                      {selectedUser.id
                        ? "Edit Receipt Payment"
                        : "Add Receipt Payment"}
                    </h5>
                    <button
                      type="button"
                      onClick={closePopup}
                      aria-label="Close"
                      style={{
                        marginLeft: "90%",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                        marginTop: "-40px",
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                </div>
              </div>
            </div>
          )}

          <TableContainer component={Paper} style={{ marginTop: '16px', width: '100%', marginBottom: "20px" }}>
            <Table sx={{ minWidth: 650 }} >
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellStyle}>Actions</TableCell>
                  <TableCell sx={headerCellStyle}>Select</TableCell>
                  <TableCell sx={headerCellStyle}>ID</TableCell>
                  <TableCell sx={headerCellStyle}>Party Code</TableCell>
                  <TableCell sx={headerCellStyle}>Party Name</TableCell>
                  {/* <TableCell sx={headerCellStyle}>Unit Code</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>Unit Name</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>Mill Code</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>Mill Name</TableCell> */}
                  <TableCell sx={headerCellStyle}>Lorry No</TableCell>
                  <TableCell sx={headerCellStyle}>Bill No</TableCell>
                  <TableCell sx={headerCellStyle}>Bill Tran</TableCell>
                  <TableCell sx={headerCellStyle}>Bill Date</TableCell>
                  <TableCell sx={headerCellStyle}>Quantal</TableCell>
                  <TableCell sx={headerCellStyle}>Bill Amount</TableCell>
                  <TableCell sx={headerCellStyle}>Paid Amount</TableCell>
                  <TableCell sx={headerCellStyle}>Balance</TableCell>
                  <TableCell sx={headerCellStyle}>Amount</TableCell>
                  <TableCell sx={headerCellStyle}>Adj Amount</TableCell>
                  <TableCell sx={headerCellStyle}>OnAc</TableCell>
                  {/* <TableCell sx={headerCellStyle}>Narration</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>Bill Year</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>AutoId</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>Company_Code</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>BillAutoid</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>ac</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>uc</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>mc</TableCell> */}
                  {/* <TableCell sx={headerCellStyle}>RowAction</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user, index) => (
                  <TableRow key={user.id} sx={{
                    height: '30px', '&:hover': {
                      backgroundColor: '#f3f388',
                      cursor: "pointer",
                    },
                  }} >
                    <TableCell sx={{ padding: '4px 8px' }}>{user.rowaction}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}><Checkbox
                      // checked={user.isSelected || false}
                      checked={parseFloat(user.Value) > 0} 
                      disabled={
                        (!user.isSelected && parseFloat(globalBalanceAmount) === 0)
                      }
                      onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                    /></TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.detail_id}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Party_Code}</TableCell>
                    <TableCell sx={{ padding: '4px 8px', textAlign: 'left' }}>{user.partyname}</TableCell>
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.Unit_Code}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.unitname}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.Mill_Code}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.millname}</TableCell> */}
                    <TableCell sx={{ padding: '4px 8px' }}>{user.LorryNo}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_No}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Tran_Type}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Tran_Date}
                      {/* {user.Bill_Tran_Date &&
  new Date(user.Bill_Tran_Date).getFullYear() !== 1900
    ? new Date(user.Bill_Tran_Date).toLocaleDateString("en-GB")
    : ""} */}
                    </TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Quntal}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Amount}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Receipt}</TableCell>
                    <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Balance}</TableCell>


                    <TableCell sx={{ padding: '4px 8px' }}>
                      <TextField
                        value={user.Value || ""}
                        size="small"
                        onChange={(e) => handleInputChange(index, "Value", e.target.value)}
                        disabled={!isEditing && addOneButtonEnabled}
                      />
                    </TableCell>

                    <TableCell sx={{ padding: '4px 8px' }}>
                      <TextField
                        value={user.Adj_Value || ""}
                        size="small"
                        onChange={(e) => handleInputChange(index, "Adj_Value", e.target.value)}
                        disabled={!isEditing && addOneButtonEnabled}
                      />
                    </TableCell>

                    <TableCell sx={{ padding: '4px 8px' }}>
                      <TextField
                        value={user.OnAc || ""}
                        size="small"
                        onChange={(e) => handleInputChange(index, "OnAc", e.target.value)}
                        disabled={!isEditing && addOneButtonEnabled}
                      />
                    </TableCell>

                    {/* <TableCell sx={{ padding: '4px 8px' }}>
                      <TextField
                        value={user.Narration || ""}
                        size="small"
                        onChange={(e) => handleInputChange(index, "Narration", e.target.value)}
                        disabled={!isEditing && addOneButtonEnabled}
                      />
                    </TableCell> */}

                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Year_Code}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.mrd_no}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.bill_comp_code}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.Bill_Auto_Id}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.pc}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.uc}</TableCell> */}
                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.mc}</TableCell> */}

                    {/* <TableCell sx={{ padding: '4px 8px' }}>{user.rowaction}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </div>
        <div className="receiptpaymentdiv" style={{ marginTop: "10px", marginBottom: '60px', width: "30%" }}>
          <label htmlFor="total" className="receiptpaymentlabel">Total:</label>
          <input
            type="text"
            id="total"
            name="total"
            value={formatReadableAmount(globalTotalAmount)}
            onChange={handleChange}
            disabled
          />
          <label htmlFor="total" className="receiptpaymentlabel">Balance:</label>
          <input
            type="text"
            id="Balance"
            name="Balance"
            value={formatReadableAmount(globalBalanceAmount)}
            onChange={handleChange}
            disabled
          />
        </div>
      </div>
    </>
  );
};
export default MultpleRecieptPayment;